import { Helmet } from "react-helmet-async";

export default function SEO({ title, description, image, path = "" }) {
  const site = "Wilshire Buildcon Co.";
  const full = title ? `${title} | ${site}` : `${site} — Buy. Sell. Rent. With Trust.`;
  const desc = description || "India's trusted name in property solutions. Verified plots, villas, offices, warehouses and industrial spaces across Indore and Pan India.";
  const url = `https://wilshirebuildcon.com${path}`;
  const img = image || "https://customer-assets.emergentagent.com/job_c2d60326-c63d-4493-a9f3-05c9809e41ff/artifacts/xu6a5ozf_logo.jpeg";
  return (
    <Helmet>
      <title>{full}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={full} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={img} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={full} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
    </Helmet>
  );
}
